module.exports = __webpack_public_path__ + "img/9791155310113.b2ad2e7d.jpg";